/**
 * Structured Data (Schema.org) for SEO
 * This helps search engines understand your website content better
 */

export const addStructuredData = (schema) => {
  // Remove old schema script if exists
  const oldSchema = document.querySelector('script[type="application/ld+json"]');
  if (oldSchema) {
    oldSchema.remove();
  }

  // Create new schema script
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.textContent = JSON.stringify(schema);
  document.head.appendChild(script);
};

// Organization Schema
export const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Vedamarga',
  url: 'https://vedamarga.com',
  logo: 'https://vedamarga.com/logo.png',
  description: 'Online Vedic pooja booking and ritual services',
  sameAs: [
    // Add social media profiles
    'https://www.facebook.com/vedamarga',
    'https://www.instagram.com/vedamarga',
    'https://www.youtube.com/vedamarga',
  ],
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'Customer Service',
    email: 'support@vedamarga.com',
    // Add phone if available
  },
};

// LocalBusiness Schema
export const localBusinessSchema = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  name: 'Vedamarga - Vedic Pooja Services',
  image: 'https://vedamarga.com/logo.png',
  description: 'Online Vedic ritual and pooja booking services',
  url: 'https://vedamarga.com',
  telephone: '+91-XXXXXXXXXX', // Add your phone number
  address: {
    '@type': 'PostalAddress',
    streetAddress: '', // Add if available
    addressLocality: 'India',
    addressRegion: 'India',
    postalCode: '',
    addressCountry: 'IN',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: '20.5937', // India's approximate center
    longitude: '78.9629',
  },
};

// Service Schema (for Pooja/Ritual Services)
export const serviceSchema = (service = {}) => {
  const {
    name = 'Vedic Pooja Service',
    description = 'Authentic Vedic ritual and pooja services',
    image = 'https://vedamarga.com/service-image.jpg',
    price = '',
    priceCurrency = 'INR',
  } = service;

  return {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name,
    description,
    image,
    provider: {
      '@type': 'LocalBusiness',
      name: 'Vedamarga',
      url: 'https://vedamarga.com',
    },
    ...(price && {
      offers: {
        '@type': 'Offer',
        price,
        priceCurrency,
        availability: 'https://schema.org/InStock',
      },
    }),
  };
};

// Product Schema (for Pooja packages)
export const productSchema = (product = {}) => {
  const {
    name = 'Vedic Pooja Package',
    description = 'Authentic Vedic ritual package',
    image = 'https://vedamarga.com/product-image.jpg',
    price = '',
    priceCurrency = 'INR',
    rating = 4.5,
    reviewCount = 100,
  } = product;

  return {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name,
    image,
    description,
    offers: {
      '@type': 'Offer',
      url: 'https://vedamarga.com/pooja-details',
      priceCurrency,
      price,
      availability: 'https://schema.org/InStock',
    },
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: rating,
      reviewCount,
    },
  };
};

// FAQPage Schema
export const faqSchema = (faqs = []) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };
};

// Breadcrumb Schema (for navigation)
export const breadcrumbSchema = (items = []) => {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
};
